"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = syncPresenterAttendeeIds;
var _utils = require("../../../utils");
var _types = require("../types");
function syncPresenterAttendeeIds() {
  var attendeeIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return (0, _utils.actionCreator)(_types.BROADCAST_SYNC_PRESENTER_ATTENDEE_IDS, attendeeIds);
}